<template>
    <div class="chosedialog ">
        <el-dialog :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" custom-class="body_dilog shoudafangdialag" append-to-body>
            <div class="h-rowIn" >
                <div class="h-rowBox">
                    <div class="h-rowCon yxline">
                        <div class="h-formbLine" style="margin-bottom: 1px;">
                            <el-form :inline="true" :model="q" @submit.native.prevent class="demo-form-inline h-formBorder" style="margin-left:-1.84rem">
                                <el-form-item label="sap订单号"  style="width: 80%;">
                                    <el-input clearable v-model="q.sapCode"></el-input>
                                </el-form-item>
                                <el-form-item style="margin-top:-20px">
                                    <el-button type="primary" class="w-tongyi"  icon="el-icon-search" @click="handleFilter" >搜索</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <el-table
                                max-height="500px"
                                size="mini"
                                ref="multipleTable"
								:border="true"
                                :data="ttdata"
                                tooltip-effect="dark"
                                style="width: 100%"
                                @selection-change="handleSelectionChange"
                        >
                            <el-table-column
                                    type="selection"
                                    fixed
                                    width="55">
                            </el-table-column>
                          <el-table-column
                              prop="sapCode"
                              label="订单号"
                              :show-overflow-tooltip="true"
                              width="120">
                          </el-table-column>
                          <el-table-column
                              prop="soldToName"
                              label="售达方名称"
                              :show-overflow-tooltip="true"
                              width="180">
                            <template scope="scope">
                              <div style="text-align: left;">
                                {{scope.row.soldToName}}
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column
                              prop="proNumber"
                              label="数量"
                              width="60">
                            <template scope="scope">
                              <div style="text-align: right;">
                                {{scope.row.proNumber}}
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column
                              prop="prodtype"
                              label="自产/OEM"
                              width="100">
                          </el-table-column>
                          <el-table-column
                              prop="saleGroupCode"
                              label="销售组织"
                              :show-overflow-tooltip="true"
                              width="260">
                            <template scope="scope">
                              <div style="text-align: left;">
                                [{{scope.row.saleGroupCode}}]{{scope.row.saleGroupCode|dictname('YLSalesOrganization_agent')}}
                              </div>
                            </template>
                          </el-table-column>

                          <el-table-column
                              prop="soldToAreaName"
                              label="售达方地区"
                              :show-overflow-tooltip="true"
                              width="110">
                          </el-table-column>
                          <el-table-column
                              prop="toCompanyname"
                              label="收货单位"
                              :show-overflow-tooltip="true"
                              width="180">
                            <template scope="scope">
                              <div style="text-align: left;">
                                {{scope.row.toCompanyname}}
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column
                              prop="contactName"
                              label="收货联系人"
                              width="110">
                          </el-table-column>
                          <el-table-column
                              prop="acceptTime"
                              label="签收时间"
                              :show-overflow-tooltip="true"
                              width="100">
                          </el-table-column>

                        </el-table>
                        <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                            <paginationmin :page="q" @query="queryUser"/>
                          <el-button class="w-tongyi" type="primary"  @click="choseSelected">选择</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    export default {
        data(){
          return {

              q:{
                  pageSize:10,
                  pageNo:1,
                  total:0,

                  usercodename:null,
              },
              ttdata:null,
              users:[]
          }
        },
        computed: {
            Ddlx:function () {
                return this.ddlx
            },
            XmCode:function () {
                return this.xmcode
            },
            UserCode:function () {
                return this.usercode
            },
            AreaCode:function () {
                return this.areacode
            },
            Xszz:function () {
                return this.xszz
            }
        },
        methods: {
            handleFilter(){
                this.queryUser();
            },
            queryUser(p){
                this.q.xmcode = this.XmCode;
                this.q.usercode = this.UserCode;
                this.q.ddlx = this.ddlx;
                this.q.areacode = this.AreaCode;
                this.q.xszz = this.Xszz;
                if (this.orderLoud != undefined){
                  this.q.orderLoud = this.orderLoud;
                }
                ss.wuliaoselect.selectOrderThList(this.q).then(rd=>{
                    this.q.total = rd.total;
                    this.ttdata = rd.records;
                })
            },
            choseSelected(){
              console.log("chchchchchch",this.lists)
              this.$emit('choseObj', this.lists)
            },
            handleSelectionChange(users){
              console.log(users)
                if(this.oneflag){
                    this.$emit('choseObj', users[0])
                }else{
                    this.$emit('choseObj', users)
                }
            },
        },
        created(){
            this.queryUser()
        },
        props: {
            dialogVisible: {
                type: Boolean,
            },
            areacode:{
                type:String,
            },
            usercode:{
                type:String,
            },
            //项目编码
            xmcode:{
                type:String,
            },
            //订单类型
            ddlx:{
                type:String,
            },
            xszz:{
                type:String,
            },
            oneflag:{
                type:Boolean,
            },
            //订单关联漏斗
            orderLoud:{
              type:String,
            },
        }
    }
</script>

<style>
    .shoudafangdialag .el-dialog__header{
        padding-top: 20px;
        padding-left: 20px;
    }
    .shoudafangdialag .el-dialog__body{
        padding: 20px;
    }
    .shoudafangdialag .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .shoudafangdialag .h-formbLine .el-form-item__label{
        width: 39%;
    }
    .shoudafangdialag  .h-formbLine .el-form-item__content{
        width: 55%;
    }
    .shoudafangdialag .yxline .h-formbLine .el-form-item__content{
		 width: 55%;
	}
    .shoudafangdialag .yxline{
		padding-top: 0;
	}
    .shoudafangdialag .h-pagination{
        padding-top: 0rem;
        padding-bottom: 0rem;
    }
    .shoudafangdialag .h-rowCon{
        padding-bottom: 0rem;
    }
</style>
